import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['69 técnicas probadas para estimular sin parar', '29 movimientos que van a enloquecer a cualquiera', '15 tips de confianza y actitud irresistible', 'El mejor contenido digital para dominar el arte del placer'];
  return <section className="py-20 bg-[#1A0230] relative px-4 sm:px-6 lg:px-8" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-13">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-14">
            Después de acceder a estas guías, vas a perder el miedo, la
            vergüenza y te vas a convertir en una{' '}
            <span className="text-[#FF2D8A]" data-id="element-15">EXPERTA</span> en el arte del
            placer oral
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-17">
              <CheckCircle2Icon className="w-8 h-8 text-[#FF2D8A] shrink-0 mr-4 mt-1" data-id="element-18" />
              <p className="text-lg text-gray-200 font-medium" data-id="element-19">{benefit}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}